import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Fade } from 'react-reveal';
import Icon from '../../components/Icons/Icon';
import * as roles from '../Home/roles.json';
import './About.css';

export default class About extends Component {

  state = {
    image: <div />,
    paragraphs: [],
    found: true
  }

  componentWillReceiveProps(nextProps){
    if (this.props.match && !nextProps.match){
      this.reset();
    }
  }

  componentDidMount() {
    this.props.setPage("about");
    if (this.props.match) {
      let data = roles[JSON.parse(JSON.stringify(roles)).findIndex(e => e.name === this.props.match.params.focus)] || false;
      if (data) {
        this.setState({
          image: <Icon {...data} />,
          paragraphs: data.paragraphs.map((e, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: e }} />
          ))
        });
      }
      else {
          this.setState({
            found: false
          });
      }
    }
    else {
      this.reset();
    }
  }

  reset = () => {
    this.setState({
      image: <img className="pic" src="/images/evan.jpg" alt="Evan Simon Ross" width="256px" />,
      paragraphs: [
        <p key={0}><Link to="/"><b>Evan Simon Ross</b></Link> is a Web Developer with a passion for interdisciplinary projects. He is an experienced educator in English as a Second Language for adult students, where communication skills and patience are vital. A creative thinker and persistent problem-solver, Evan is looking to deploy next-generation web technologies to improve the lives of English students and others worldwide. </p>,
        <p key={1}> Evan is a graduate of the first-ever Columbia University Coding Bootcamp in Full Stack Web Development. This page itself is one of his many web development projects completed during or after this program, and includes information on many of the others. Please check out the <Link to="/projects" className="link"><b>Projects</b></Link> page for more of his web development work.</p>,
        <p key={2}> In future, this page will be expanded to include projects related to Evan's many other diverse interests, including music, writing, and conlanging. Stay tuned! </p>,
      ]
    })
  }

  render() {

    if(!this.state.found) return <Redirect to="/404"/>

    return (
      <div className="about">
        <h1>Who is Evan?</h1>
        <Fade>
          <div>
            {this.state.image}
            {this.state.paragraphs}
            <br/>
          </div>
        </Fade>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/About/About.js